import React, { useState, useEffect } from 'react';
import axios from 'axios';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import SearchIcon from '@mui/icons-material/Search';
import * as XLSX from 'xlsx';
import { fetchData, deleteData, activateData } from '../../../apiService';
import { useAuth } from '../../../AuthContext';
import { tokenIsExpired } from '../../../authUtils';
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import { IconButton } from '@mui/material';
import InfoIcon from '@mui/icons-material/Info';
import { Link } from 'react-router-dom'; // Import Link from react-router-dom
import Button from '@mui/material/Button';
import RefreshIcon from '@mui/icons-material/Refresh';
import FeedIcon from '@mui/icons-material/Feed';
import Select from 'react-select'; // Import react-select
import CircularProgress from '@mui/material/CircularProgress';

function Ledger() {
    const [dataBill, setDataBill] = useState([]);
    const [dataItem, setDataItem] = useState([]);
    const [searchQuery, setSearchQuery] = useState('');
    const [showSearchInput, setShowSearchInput] = useState(false);
    const tableRef = React.createRef();
    const [fromDate, setFromDate] = useState('');
    const [toDate, setToDate] = useState('');
    const [selectedOption, setSelectedOption] = useState('itemWise');
    const [customerOptions, setCustomerOptions] = useState([]);
    const [selectedCustomer, setSelectedCustomer] = useState(null);
    const [customerId, setCustomer] = useState('');
    const { isAuthenticated, companyId, permissions, token, logout } = useAuth();
    const [loading, setLoading] = useState(false);


    useEffect(() => {
        if (isAuthenticated && tokenIsExpired(token)) {
            logout();
            return;
        }
        setFromDate(getFormattedStartDate());
        setToDate(getFormattedCurrentDate());
        fetchTableData();
        fetchCustomerData();
    }, [isAuthenticated, companyId, token, logout]);


    // Handle customer selection
    const handleCustomerSelect = (selectedOption) => {
        setSelectedCustomer(selectedOption);
        const customerId = selectedOption ? selectedOption.value : '';
        setCustomer(customerId);
        setDataItem([])
    };


    //FOR GET Customer  Details FROM API
    const fetchCustomerData = () => {
        fetchData('ReportApi', `/Customer/${companyId}`, token)
            .then((response) => response.response_data)
            .then((data) => {
                // Transform the data into the format that react-select expects (label and value)
                const options = data.map((customer) => ({
                    label: customer.Name,
                    value: customer.ID,
                }));
                setCustomerOptions(options);
            })
            .catch((error) => {
                console.error('Error fetching customer data:', error);
            });
    };

    const getFormattedCurrentDate = () => {
        const currentDate = new Date();
        return currentDate.toISOString().split('T')[0];
    };

    // const getFormattedStartDate = () => {
    //     const monthStartDate = new Date();
    //     monthStartDate.setDate(1);
    //     return monthStartDate.toISOString().split('T')[0];
    // };

    const getFormattedStartDate = () => {
        const today = new Date();
        let year = today.getFullYear();

        if (today.getMonth() + 1 > 3) {
            // If the current month is greater than 3, use the current year
            return `${year}-04-01`;
        } else {
            // If the current month is 3 or less, use the previous year
            return `${year - 1}-04-01`;
        }
    };


    const handleFromDateChange = (e) => {
        const selectedDate = e.target.value;
        // Add validation if needed
        setFromDate(selectedDate);
    };

    // Similar function for toDate
    const handleToDateChange = (e) => {
        const selectedDate = e.target.value;
        // Add validation if needed
        setToDate(selectedDate);
    };

    const hasReadReportPermission = permissions.includes('Read Reports');

    const handleChange = (event) => {
        setSelectedOption(event.target.value);
    };

    const fetchTableData = async () => {
        if (hasReadReportPermission) {
            setDataItem([])
            setLoading(true);

            try {
                const response = await fetchData('ReportApi', `/Ledger/${companyId}/${customerId}/${fromDate}/${toDate}`, token);
                if (response.responseCode === '1111') {
                    setDataItem(response.response_data);

                }
            } catch (error) {
                console.error('Error fetching Packing Slip Details:', error);
            }
            finally {
                setLoading(false); // Hide loading screen
            };
        }
    };

    const handleSearch = (event) => {
        setSearchQuery(event.target.value);
    };

    const toggleSearchInput = () => {
        setShowSearchInput(!showSearchInput);
    };

    const filteredDataBill = dataBill.filter((item) =>
        Object.values(item).some((value) =>
            String(value).toLowerCase().includes(searchQuery.toLowerCase())
        )
    );

    const filteredDataItem = dataItem.filter((item) =>
        Object.values(item).some((value) =>
            String(value).toLowerCase().includes(searchQuery.toLowerCase())
        )
    );

    const formatDate = (dateString) => {
        const options = { year: 'numeric', month: '2-digit', day: '2-digit' };
        return new Date(dateString).toLocaleDateString('en-GB', options);
    };

    const handleExportExcel = () => {
        const excelData = [];

        // Add header row

        const headerCaption = [`Ledger for ${selectedCustomer ? selectedCustomer.label : 'All Customers'} From : ${formatDate(fromDate)} To : ${formatDate(toDate)}`];
        excelData.push(headerCaption)
        const headerRow = ['Date', 'Description', 'Credit', 'Debit'];
        excelData.push(headerRow);

        // Add data rows
        filteredDataItem.forEach((rowData, index) => {
            const dataRow = [];
            if (rowData.description1 === 'Opening Balance' || rowData.description1 === 'Closing Balance') {
                dataRow.push('', rowData.description1, rowData.credit, rowData.debit);
            } else if (rowData.description1 === 'Total') {
                dataRow.push('', '', rowData.credit, rowData.debit);
            } else {
                dataRow.push(formatDate(rowData.date1), rowData.description1, rowData.credit, rowData.debit);
            }
            excelData.push(dataRow);
        });




        const ws = XLSX.utils.aoa_to_sheet(excelData);
        const wb = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, ws, 'Ledger');

        // Set alignment for total quantity cell
        const wsCols = [
            { wch: 15 }, // Date
            { wch: 35 }, // Description
            { wch: 15 }, // Credit
            { wch: 15 }, // Debit          
        ];
        ws['!cols'] = wsCols;

        XLSX.writeFile(wb, 'Ledger.xlsx');
    };



    const handlePrint = () => {
        const printWindow = window.open('', '_blank');
        if (!printWindow) {
            console.error('Failed to open print window.');
            return;
        }

        printWindow.document.write('<html><head><title>Ledger</title></head><body>');
        // Create title including customer name and date range
        const title = `Ledger for ${selectedCustomer ? selectedCustomer.label : 'All Customers'} (Customer)`;
        printWindow.document.write('<html><head><title>' + title + '</title></head><body>');
        printWindow.document.write(`<h4 style="font-family: Times New Roman; font-size: 22px;">From : ${formatDate(fromDate)} To : ${formatDate(toDate)}</h4>`);
        printWindow.document.write('<table style="border-collapse: collapse; width: 100%;">');
        printWindow.document.write('<thead style="background-color: #f3f3f3;">');
        printWindow.document.write('<tr>');
        printWindow.document.write('<th style="border: 1px solid #ddd; font-size: 19px; font-weight: bolder; color: black;">Date</th>');
        printWindow.document.write('<th style="border: 1px solid #ddd; font-size: 19px; font-weight: bolder; color: black;">Description</th>');
        printWindow.document.write('<th style="border: 1px solid #ddd; font-size: 19px; font-weight: bolder; color: black;">Credit</th>');
        printWindow.document.write('<th style="border: 1px solid #ddd; font-size: 19px; font-weight: bolder; color: black;">Debit</th>');
        printWindow.document.write('</tr>');
        printWindow.document.write('</thead>');
        printWindow.document.write('<tbody>');

        filteredDataItem.forEach((rowData, index) => {
            printWindow.document.write('<tr>');

            if (rowData.description1 === 'Opening Balance' || rowData.description1 === 'Closing Balance') {
                printWindow.document.write(`<td style="border: 1px solid #ddd; font-size: 16px; font-weight: bolder;"></td>`);
                printWindow.document.write(`<td style="border: 1px solid #ddd; font-size: 16px; font-weight: bolder;">${rowData.description1}</td>`);
            } else if (rowData.description1 === 'Total') {
                printWindow.document.write(`<td style="border: 1px solid #ddd; font-size: 16px;"></td>`);
                printWindow.document.write(`<td style="border: 1px solid #ddd; font-size: 16px;"></td>`);
            }
            else {
                printWindow.document.write(`<td style="border: 1px solid #ddd; font-size: 16px;">${formatDate(rowData.date1)}</td>`);
                printWindow.document.write(`<td style="border: 1px solid #ddd; font-size: 16px;">${rowData.description1}</td>`);
            }

            printWindow.document.write(`<td style="border: 1px solid #ddd; font-size: 16px;">${rowData.credit}</td>`);
            printWindow.document.write(`<td style="border: 1px solid #ddd; font-size: 16px;">${rowData.debit}</td>`);

            printWindow.document.write('</tr>');
        });

        printWindow.document.write('</tbody>');
        printWindow.document.write('</table>');
        printWindow.document.write('</body></html>');

        printWindow.document.close();
        printWindow.print();
    };

    let bal = 0;    // Running balance

    const computeBalance = (data) => {

        if (data.description1 !== 'Closing Balance' && data.description1 !== 'Total') {
            // Add debit to balance
            if (data.debit) {
                bal += Math.abs(data.debit);
            }
            // Subtract credit from balance
            if (data.credit) {
                bal -= Math.abs(data.credit);
            }
        }

        // Return balance string with "Dr" or "Cr"
        if (data.description1 !== 'Closing Balance' && data.description1 !== 'Total') {
            return bal > 0 ? `${bal.toFixed(2)}  Dr` : `${Math.abs(bal).toFixed(2)}  Cr`;
        }
        return '';
    };

    return (
        <div className="w-full max-w-sm container mt-6 mx-auto" style={{ maxWidth: '97%' }}>
            <h6 style={{ flexGrow: 1, color: 'linkColor', fontFamily: 'Times New Roman', whiteSpace: 'nowrap', marginRight: '8px' }}>
                CUSTOMER LEDGER
            </h6>
            {loading && (
                <div style={{
                    position: 'fixed',
                    top: 0,
                    left: 0,
                    width: '100%',
                    height: '100%',
                    backgroundColor: 'rgba(0, 0, 0, 0.5)',
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    zIndex: 9999
                }}>
                    <div>
                        <CircularProgress style={{ color: 'white' }} />
                        <span style={{ color: 'white', marginTop: '10px', display: 'block' }}>Loading...</span>
                    </div>
                </div>
            )}
            <div style={{ width: '100%', marginBottom: '2', display: 'flex', flexWrap: 'nowrap', alignItems: 'center' }}>

                <div style={{ width: '100%', maxWidth: '40%', paddingRight: '2', marginBottom: '2', flexBasis: 'auto' }}> {/* Adjusted width for smaller screens */}
                    <label style={{ display: 'block', color: 'gray', fontSize: '16px', fontWeight: 'bold', marginBottom: '2' }} htmlFor="party">
                        Customer
                        <span style={{ color: 'red' }}>*</span>
                    </label>
                    <Select
                        options={customerOptions}
                        value={selectedCustomer}
                        onChange={handleCustomerSelect}
                        placeholder="Select a customer"
                        style={{ width: '100%' }}
                        styles={{
                            menu: (provided) => ({
                                ...provided,
                                zIndex: 1301,
                            }),
                            control: (provided) => ({
                                ...provided,
                                //  width: '350px',
                            }),
                        }}
                        isSearchable
                    />
                </div>
                <div style={{ marginRight: '2', maxWidth: '150px', marginLeft: '10px' }}>
                    <label style={{ display: 'block', color: 'gray', fontSize: '16px', fontWeight: 'bold', marginBottom: '2' }} htmlFor="fromDate">
                        From Date
                    </label>
                    <input
                        className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                        type="date" value={fromDate} onChange={handleFromDateChange}
                        style={{ shadow: 'appearance-none', border: 'rounded', width: '100%', paddingY: '2', paddingX: '3', color: 'gray-700', leadingTight: true, focus: { color: 'gray-600', shadow: 'outline' } }}
                    />
                </div>
                <div style={{ marginRight: '2', maxWidth: '150px', marginLeft: '10px' }}>
                    <label style={{ display: 'block', color: 'gray', fontSize: '16px', fontWeight: 'bold', marginBottom: '2' }} htmlFor="toDate">
                        To Date
                    </label>
                    <input
                        className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                        type="date" value={toDate} onChange={handleToDateChange}
                        style={{ shadow: 'appearance-none', border: 'rounded', width: '100%', paddingY: '2', paddingX: '3', color: 'gray-700', leadingTight: true, focus: { color: 'gray-600', shadow: 'outline' } }}
                    />
                </div>

                <Button
                    style={{
                        marginRight: '8px',
                        background: 'linear-gradient(to right, darkslategray, slategray)',
                        borderRadius: '50px',
                        padding: '10px 20px',
                        color: 'white',
                        fontWeight: 'bolder',
                        textTransform: 'none',
                        boxShadow: '0 4px 6px rgba(0, 0, 0, 0.3)',
                        maxHeight: '35px',
                        marginTop: '15px',
                        marginLeft: '10px'

                    }}
                    //style={{ color: "black", backgroundColor: '#7FE87F', height: '36px', marginLeft: '10px' }}
                    onClick={fetchTableData}
                    className="linkcolor"
                >
                    <IconButton onClick={fetchTableData}>
                        <RefreshIcon style={{ color: 'white' }} />
                    </IconButton>
                    Refresh
                </Button>

                <Button
                    style={{
                        marginRight: '8px',
                        background: 'linear-gradient(to right, darkslategray, slategray)',
                        borderRadius: '50px',
                        padding: '10px 20px',
                        color: 'white',
                        fontWeight: 'bolder',
                        textTransform: 'none',
                        boxShadow: '0 4px 6px rgba(0, 0, 0, 0.3)',
                        maxHeight: '35px',
                        marginTop: '15px'

                    }}
                    //style={{ color: "black", backgroundColor: '#66C0B7', height: '36px', marginLeft: '10px' }}
                    onClick={handleExportExcel}
                    className="linkcolor"
                >
                    <IconButton onClick={handleExportExcel}>
                        <FeedIcon style={{ color: 'white' }} />
                    </IconButton>
                    Excel
                </Button>

                <Button
                    style={{
                        marginRight: '8px',
                        background: 'linear-gradient(to right, darkslategray, slategray)',
                        borderRadius: '50px',
                        padding: '10px 20px',
                        color: 'white',
                        fontWeight: 'bolder',
                        textTransform: 'none',
                        boxShadow: '0 4px 6px rgba(0, 0, 0, 0.3)',
                        maxHeight: '35px',
                        marginTop: '15px'

                    }}
                    //style={{ color: "black", backgroundColor: '#FFAB99', height: '36px', marginLeft: '10px' }}
                    onClick={handlePrint}
                    className="linkcolor"
                >
                    <IconButton onClick={handlePrint}>
                        <FeedIcon style={{ color: 'white' }} />
                    </IconButton>
                    Print
                </Button>

            </div>


            {/* <div className='w-full mb-5 flex' style={{ maxHeight: '490px', overflowY: 'auto', marginTop: '5px' }}>

                <TableContainer component={Paper}>
                    <Table>
                        <TableHead sx={{ backgroundColor: '#08396B', Width: '2500px' }}>
                            <TableRow>
                                <TableCell sx={{ borderBottom: '1px solid #ddd', fontSize: '12px', fontWeight: 'bolder', color: 'whitesmoke', textTransform: 'uppercase', padding: '3px' }}>Date</TableCell>
                                <TableCell sx={{ borderBottom: '1px solid #ddd', fontSize: '12px', fontWeight: 'bolder', color: 'whitesmoke', textTransform: 'uppercase', padding: '3px' }}>Description</TableCell>
                                <TableCell sx={{ borderBottom: '1px solid #ddd', fontSize: '12px', fontWeight: 'bolder', color: 'whitesmoke', textAlign: 'right', textTransform: 'uppercase', padding: '3px' }}>Credit</TableCell>
                                <TableCell sx={{ borderBottom: '1px solid #ddd', fontSize: '12px', fontWeight: 'bolder', color: 'whitesmoke', textAlign: 'right', textTransform: 'uppercase', padding: '3px' }}>Debit</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody sx={{ backgroundColor: '#5A827E' }}>
                            {filteredDataItem.map((data, index) => (
                                <TableRow key={data.id} sx={data.description1 === 'Total' || data.description1 === 'Opening Balance' || data.description1 === 'Closing Balance' ? { backgroundColor: '#24203C' } : null}>
                                    {data.description1 === 'Total' || data.description1 === 'Opening Balance' || data.description1 === 'Closing Balance' ? (

                                        <TableCell sx={{ fontSize: '14px', height: '30px', padding: '11px', fontWeight: 'bolder', color: 'whitesmoke' }}></TableCell>
                                    ) : (
                                        <TableCell sx={{ fontSize: '14px', height: '30px', padding: '11px', color: 'whitesmoke' }}>{formatDate(data.date1)}</TableCell>
                                    )}

                                    {data.description1 === 'Total' ? (

                                        <TableCell sx={{ fontSize: '15px', height: '30px', padding: '11px', fontWeight: 'bolder', color: 'whitesmoke' }}></TableCell>
                                    ) : (
                                        <TableCell sx={{ fontSize: '15px', height: '30px', padding: '11px', color: 'whitesmoke', fontWeight: data.description1 === 'Opening Balance' || data.description1 === 'Closing Balance' ? 'bolder' : 'normal' }}>{data.description1}</TableCell>
                                    )}

                                    <TableCell sx={{ fontSize: '15px', height: '30px', padding: '11px', textAlign: 'right', color: 'whitesmoke', fontWeight: data.description1 === 'Total' || data.description1 === 'Opening Balance' || data.description1 === 'Closing Balance' ? 'bolder' : 'normal' }}>{data.credit.toFixed(2)}</TableCell>
                                    <TableCell sx={{ fontSize: '15px', height: '30px', padding: '11px', textAlign: 'right', color: 'whitesmoke', fontWeight: data.description1 === 'Total' || data.description1 === 'Opening Balance' || data.description1 === 'Closing Balance' ? 'bolder' : 'normal' }}>{data.debit.toFixed(2)}</TableCell>
                                </TableRow>
                            ))}
                        </TableBody>
                    </Table>
                </TableContainer>



            </div> */}

            <div className='w-full mb-5 flex' style={{ maxHeight: '500px', overflowY: 'auto', marginTop: '5px' }}>

                <TableContainer component={Paper}>
                    <Table stickyHeader>
                        <TableHead sx={{ backgroundColor: '#102E50' }}>
                            <TableRow>
                                <TableCell sx={{ backgroundColor: '#102E50', borderBottom: '1px solid #ddd', fontSize: '12px', color: 'whitesmoke', padding: '4px', fontWeight: 'bold', textTransform: 'uppercase' }}>Date</TableCell>
                                <TableCell sx={{ backgroundColor: '#102E50', borderBottom: '1px solid #ddd', fontSize: '12px', color: 'whitesmoke', padding: '4px', fontWeight: 'bold', textTransform: 'uppercase' }}>Description</TableCell>
                                <TableCell sx={{ backgroundColor: '#102E50', borderBottom: '1px solid #ddd', fontSize: '12px', color: 'whitesmoke', textAlign: 'right', padding: '4px', fontWeight: 'bold', textTransform: 'uppercase' }}>Debit</TableCell>
                                <TableCell sx={{ backgroundColor: '#102E50', borderBottom: '1px solid #ddd', fontSize: '12px', color: 'whitesmoke', textAlign: 'right', padding: '4px', fontWeight: 'bold', textTransform: 'uppercase' }}>Credit</TableCell>
                                <TableCell sx={{ backgroundColor: '#102E50', borderBottom: '1px solid #ddd', fontSize: '12px', color: 'whitesmoke', textAlign: 'right', padding: '4px', fontWeight: 'bold', textTransform: 'uppercase' }}>Balance</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {filteredDataItem.map((data, index) => (
                                <TableRow key={data.id} sx={data.description1 === 'Opening Balance' || data.description1 === 'Closing Balance' || data.description1 === 'Total' ? { backgroundColor: '#f0f0f0' } : null} style={{ textTransform: 'uppercase', fontSize: '12px' }}>

                                    {data.description === 'Opening Balance' || data.description1 === 'Closing Balance' || data.description1 === 'Total' ? (

                                        <TableCell sx={{ padding: '5px', fontWeight: 'bolder' }}></TableCell>
                                    ) : (
                                        <TableCell sx={{ padding: '5px' }}>{formatDate(data.date1)}</TableCell>
                                    )}
                                    {data.description1 === 'Total' ? (

                                        <TableCell sx={{ fontSize: '14px', height: '30px', padding: '5px', fontWeight: 'bolder', color: 'black' }}></TableCell>
                                    ) : (
                                        <TableCell sx={{ fontSize: '14px', height: '30px', padding: '5px', color: 'black', fontWeight: data.description1 === 'Opening Balance' || data.description1 === 'Closing Balance' ? 'bolder' : 'normal' }}>{data.description1}</TableCell>
                                    )}

                                    <TableCell sx={{ fontSize: '14px', height: '30px', padding: '5px', textAlign: 'right', fontWeight: data.description1 === 'Opening Balance' || data.description1 === 'Closing Balance' || data.description1 === 'Total' ? 'bolder' : 'normal' }}> {data.debit != null ? data.debit.toFixed(2) : ''}</TableCell>
                                    <TableCell sx={{ fontSize: '14px', height: '30px', padding: '5px', textAlign: 'right', fontWeight: data.description1 === 'Opening Balance' || data.description1 === 'Closing Balance' || data.description1 === 'Total' ? 'bolder' : 'normal' }}> {data.credit != null ? data.credit.toFixed(2) : ''}</TableCell>
                                    <TableCell
                                        sx={{
                                            fontSize: '14px',
                                            height: '30px',
                                            padding: '5px',
                                            textAlign: 'right',
                                            width: '150px',
                                            fontWeight: 'bolder',
                                        }}
                                    >
                                        {computeBalance(data)}
                                    </TableCell>
                                </TableRow>
                            ))}
                        </TableBody>
                    </Table>
                </TableContainer>

            </div>
        </div>
    );
}

export default Ledger;

